import { TemplateRef } from '@angular/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ViewStateOptions } from '@src/suite/common/data-models/navigation/viewstate-options';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';

export const ViewStateActions = createActionGroup({
    source: 'ViewState',
    events: {
        'Set current application': props<{ application: string }>(),
        'Set current view state': props<{ vs: ViewStateRecord }>(),
        'Set current view state success': props<{ vs: ViewStateRecord; layout: ViewStateOptions; sortBy?: ViewStateOptions; groupBy?: ViewStateOptions }>(),
        'Set current view state error': props<{ error: string }>(),
        'Set current slideshow view state': props<{ vs: ViewStateRecord }>(),
        'Add view state filters': props<{ required: boolean; filters: Array<string> }>(),
        'Remove view state filter': props<{ required: boolean; filter: string }>(),
        'Update view state filter': emptyProps(),
        'Update view state filter state': props<{ opened: boolean }>(),
        'Update view state layout': props<{ layout: string }>(),
        'Update view state group by': props<{ groupBy: string }>(),
        'Update view state group by sort order': emptyProps(),
        'Update view state sort by': props<{ sortBy: string }>(),
        'Update view state sort by sort order': emptyProps(),
        'Update view state custom card fields': props<{ fields: Array<FieldDef> }>(),
        'Update view state revision number': props<{ revisionNumber: number }>(),
        'Update view state max revision number': props<{ vs: ViewStateRecord }>(),
        'Update view state view state guid': props<{ guid: string }>(),
        'Update view state current map center': props<{ center: any }>(),
        'Update view state current map zoom': props<{ zoom: number }>(),
        'Update view state search title ': emptyProps(),
        'Toggle view state show team locations': emptyProps(),
        'Toggle view state lock map location': emptyProps(),
        'Toggle view state zoom to coverage': emptyProps(),
        'Toggle filter state': emptyProps(),
        'Toggle filter elevation': emptyProps(),
        'Toggle planning views filter state': emptyProps(),
        'Toggle sort oder': emptyProps(),
        'Toggle group sort oder': emptyProps(),
        'Apply view state team custom card fields': props<{ fields: Array<FieldDef> }>(),
        'Update template refs': props<{ mainCta: TemplateRef<unknown>; secondaryCta: TemplateRef<unknown>; viewOptions: TemplateRef<unknown>; rightSlot: TemplateRef<unknown> }>(),
        'Adjust Date Range': props<{ firstDate: Date; lastDate: Date }>(),
        'View state changed': emptyProps(),
    },
});

export const ViewStateApiActions = createActionGroup({
    source: 'ViewState API',
    events: {
        'Apply team custom card fields': props<{ fields: Array<FieldDef>; team: string }>(),
        'Apply team custom card fields success': props<{ fields: Array<FieldDef> }>(),
        'Apply team custom card fields error': props<{ error: string }>(),

        'Load view state records': props<{ group?: string; creators?: Array<string>; application?: string }>(),
        'Load view state records success': emptyProps(),
        'Load view state records error': props<{ error: string }>(),

        'Delete view state record': props<{ vs: ViewStateRecord }>(),
        'Delete view state record success': props<{ status: boolean }>(),
        'Delete view state record error': props<{ error: string }>(),
    },
});
